import React from "react";
import KufiIcon from "../Assets/Icon/KufiIcon";
import LikeIcon from "../Assets/Icon/LikeIcon";

const SurahItem = ({
  number,
  name,
  eName,
  fill,
  listMode,
  type,
  ayahNum,
  onclick,
  onclicklike,
  selected,
  langTo,
}) => {
  return (
    <li
      className={`[transition:transform.3s] bg-white min-w-[min(160px,100%)] grow shrink-0 p-4 rounded-2xl cursor-pointer hover:scale-105 origin-bottom relative ${
        listMode === "grid" ? " w-1/6" : "w-full"
      } `}
    >
      <button
        onClick={onclicklike}
        className={`absolute ${
          listMode === "grid"
            ? "top-4 left-4"
            : "top-1/2 -translate-y-1/2 left-4"
        }`}
      >
        <LikeIcon fill={fill} />
      </button>
      <div
        className={`surah flex gap-2 p-4 -m-4  ${
          listMode === "grid" ? "flex-col" : "flex-raw"
        }`}
        onClick={onclick}
      >
        <div className=" flex justify-between items-center">
          <span className=" text-xs relative w-7 text-center skiptranslate">
            <KufiIcon />
            {number}
          </span>
        </div>
        <h3 className={`${selected && " text-[var(--MColor)]"}`}>
          {langTo === "EN"
            ? name
                .replace(/[\u064B-\u065F|\u06E1]/g, "")
                .replaceAll("ٱ", "ا")
                .replaceAll("ىٰ", "ى")
                .replaceAll("مٰ", "م")
            : eName}
        </h3>
        <span
          className={` text-[#aaa] -mt-2 text-xs notranslate  ${
            listMode === "list" && "absolute top-[50%] left-10"
          }`}
        >
          {langTo === "EN"
            ? (type === "Medinan" ? "مدنية" : "مكية") + " - " + ayahNum + " آية"
            : type + " - " + ayahNum + " verses"}
        </span>
      </div>
    </li>
  );
};

export default SurahItem;
